import InitialConsentPage from "./InitialConsentPage";

export default InitialConsentPage;
